import React from 'react';
import {FaGithub ,  FaLinkedin, FaInstagram, FaLaptop} from 'react-icons/fa';
import CountUp from 'react-countup'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { fadeIn } from '../variants';

const About = () => {
  const [ref , inView] = useInView({
    threshold: 0.5,

  })
  return(
    <section className='section' id='about' ref={ref}>
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen'>
          <motion.div
          variants={fadeIn('right',0.3)}
          initial='hidden'
          whileInView={'show'}
          viewport={{once: false , amount:0.3}}

          className='flex-1 bg-about bg-contain bg-no-repeat h-[680px] mix-blend-lighten bg-top'></motion.div>

          <motion.div 
          variants={fadeIn('left',0.3)}
          initial='hidden'
          whileInView={'show'}
          viewport={{once: false , amount:0.3}}
          className='flex-1'>
            <h2 className='h2 text-accent'>About me.</h2>

            <h3 className='h3 mb-4'> I`m a Full stack MERN developer with understanding in react and subsequent framework libraries</h3>
            
            <p className='mb-6'>
             
            </p>
            <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                 {inView? <CountUp start={0} end={25} duration={7}></CountUp> : null} +
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Months of <br/>
                  Experience
                </div>
              </div>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                 {inView? <CountUp start={0} end={30} duration={4}></CountUp> : null} +
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                 Projects <br/>
                  completed
                </div>
              </div>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                 {inView? <CountUp start={100} end={200} duration={3}></CountUp> : null} +
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Problems <br/>
                  Solved
                </div>
              </div>
            </div>
            <div className='flex gap-x-8 items-center'>
             <a href='https://leetcode.com/vishesh_tiwari/'><button className='btn btn-lg'>
                leetcode  <FaLaptop></FaLaptop>
              </button></a> 
              <a href='https://auth.geeksforgeeks.org/user/tvishesh593/practice' className='text-gradient btn-link'>GeeksforGeeks  <FaLaptop></FaLaptop></a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  ) 
};

export default About;
